import React from "react";
import styled from "styled-components";
import { useTranslation } from "@lib/i18n";
import { node, bool, func } from "prop-types";

import Typography from "@components/shared/Typography";
import SimpleButton from "@components/shared/SimpleButton";

import { fontWeight } from "@components/shared/utils";

const ContainerTitle = styled(Typography)`
  text-align: left;
  margin: 1rem 0 1.33rem;
  font-weight: ${fontWeight("bold")};
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SummaryContainer = styled.div`
  font-size: 10px;
`;

const ContainerText = styled(Typography)`
  text-align: left;
  font-weight: ${fontWeight("regular")};
`;

const Container = styled.div`
  padding: 6px;
`;

const EditableContainer = ({
  title,
  text,
  form,
  summary,
  onChange,
  isEditing,
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  const onCancelButtonClick = () => {
    onChange(false);
  };

  const onModifyButtonClick = () => {
    onChange(true);
  };

  return (
    <Container>
      <ContainerTitle>{title}</ContainerTitle>
      {isEditing ? (
        <FormContainer>
          {text && <ContainerText>{text}</ContainerText>}
          {form}
          <SimpleButton withUnderline onClick={onCancelButtonClick}>
            {t("myDetails.inputs.cancel")}
          </SimpleButton>
        </FormContainer>
      ) : (
        <SummaryContainer>
          {summary}

          {!isDisabled && (
            <SimpleButton withArrow onClick={onModifyButtonClick}>
              {t("general.modify")}
            </SimpleButton>
          )}
        </SummaryContainer>
      )}
    </Container>
  );
};

EditableContainer.propTypes = {
  title: node.isRequired,
  text: node,
  summary: node.isRequired,
  form: node,
  isDisabled: bool,
  onChange: func,
  isEditing: bool,
};

export default EditableContainer;
